const apiUrl = process.env.REACT_APP_API_URL;

export const PostBbddActivitatIdProblema = async (id_activitat: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/activitats/${id_activitat}/problema`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(json)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error al desar el problema de BBDD:', error);
        throw error;
    }
};
